import { STATIC_STRINGS } from "../../../../../utils/Constants";
import GenericAutocomplete from "../../../../../common/GenericAutocomplete";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { updateSkills } from "../../../../../store/steps/stepOneSlice";
import { Modal } from "@mui/material";

const AddSkillsModal = ({ isModalOpen, setModalOpen }) => {
  const dispatch = useDispatch();
  const skills = useSelector((state: RootState) => state.stepOne.skills);

  return (
    <Modal open={isModalOpen} onClose={() => setModalOpen("")}>
      <div className="border-2 border-neutral-dark h-1/3 w-1/3 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md bg-white absolute flex flex-col justify-around items-center">
        <div className="w-[90%] mx-auto">
          <GenericAutocomplete
            options={[...skills]}
            freeSolo={true}
            value={skills}
            onChangeHandler={(event, newValue) =>
              dispatch(updateSkills([...newValue]))
            }
            placeholder={STATIC_STRINGS.SKILLS_PLACEHOLDER}
          />
        </div>
        <div className="w-[90%] mx-auto flex justify-center items-center">
          <button className="btn btn-outline" onClick={() => setModalOpen("")}>
            {STATIC_STRINGS.CONFIRM}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default AddSkillsModal;
